export default __webpack_public_path__ + "static/media/money-transfer-icon.e669b697.svg";